import React, { useEffect } from 'react'
import { Tabs, Tab, Box } from '@mui/material'
import { useAppSearchParams } from '../../hooks/useAppSearchParams'

export const VIEW_PARAM_KEY = 'view'

enum TAB_KEYS {
  ACTIVE = 'active',
  PAST = 'past'
}

const TermsTab: React.FC = () => {
  const { searchParams, setUrlParams } = useAppSearchParams()
  const selectedView = searchParams.get(VIEW_PARAM_KEY) || TAB_KEYS.ACTIVE

  const handleTabChange = (_event: React.SyntheticEvent, newValue: string): void => {
    setUrlParams({ [VIEW_PARAM_KEY]: newValue })
  }

  useEffect(() => {
    if (!searchParams.get(VIEW_PARAM_KEY)) {
      setUrlParams({ [VIEW_PARAM_KEY]: TAB_KEYS.ACTIVE })
    }
  }, [searchParams, setUrlParams])

  return (
        <Box sx={{ borderBottom: 1, borderColor: 'divider', mt: 2, mb: 4 }}>
            <Tabs value={selectedView} onChange={handleTabChange} aria-label="Terms Tabs" >
                <Tab label="Active and Upcoming Terms" value={TAB_KEYS.ACTIVE} sx={{ fontWeight: 600 }} />
                <Tab label="Past Terms" value={TAB_KEYS.PAST} sx={{ fontWeight: 600 }} />
            </Tabs>
        </Box>
  )
}

export default TermsTab
